module.exports = __webpack_public_path__ + "img/transparent_zip.6974fdd7.svg";